import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { ExcessWithTooltip } from '../common/excess_with_tooltip';
import { ProductDocuments } from '../common/product_documents';
import { Separator } from '../common/separator';
import { withQuoteFlatten } from '../common/with_quote_flatten';

const useStyles = createUseStyles((theme) => ({
    container: {
        minHeight: theme.spacing[40]
    },
    contentContainer: {
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-evenly'
    },
    cell: {
        width: '49%',
        justifyContent: 'center',
        display: 'flex'
    }
}));

// eslint-disable-next-line valid-jsdoc
/**
 * Layout:
 * --------------------
 * |   50%  |   50%   |
 * --------------------
 */
const _ProductAdditional = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { className, productExcess, quote } = props;

    return (
        <div className={classNames('test-policyProductCard-additional', className, classes.container)}>
            <Separator type="horizontal" insideFlexbox />
            <div className={classes.contentContainer}>
                <div className={classes.cell}><ExcessWithTooltip productExcess={productExcess} /></div>
                <Separator type="vertical" insideFlexbox />
                <div className={classes.cell}><ProductDocuments quote={quote} /></div>
            </div>
            <Separator type="horizontal" insideFlexbox />
        </div>
    );
};

_ProductAdditional.propTypes = {
    className: PropTypes.string,
    quote: PropTypes.object,
    productExcess: PropTypes.number
};

const ProductAdditional = withQuoteFlatten(_ProductAdditional);

export { ProductAdditional };
